import '../../admin-shared.css'

import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { useNavigate } from 'react-router-dom'

import { PageHeader, Spinner } from '../../../../Components'
import { useCQuery } from '../../../../Services/QueryCache'
import { cap } from '../../../../State'
import { translations } from '../../../../translations'
import { actionsColumnProps, columnProps } from '../../../Prompts/Functions'
import { AdminTableActions } from '../../Components/AdminTableActions'
import { deleteSociety } from '../Editor/Functions'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

export function SocietyList() {
  const { data: societies = [], isSuccess } = useCQuery(['environments'])
  const navigate = useNavigate()

  if (!isSuccess) return <Spinner />

  return (
    <>
      <PageHeader
        title={t.societyListTitle}
        actions={
          <button
            type="button"
            className="nbtn nbtn--primary"
            onClick={() => navigate('/admin/society/new')}
          >
            <i className="pi pi-plus" style={{ fontSize: 14 }} />
            {t.createNew}
          </button>
        }
      />

      <div className="ncard admin-table-card" style={{ padding: 0 }}>
        <div className="ncard__head">
          <div className="ncard__ico">
            <i className="pi pi-building" style={{ fontSize: 16 }} />
          </div>
          <div>
            <h3 className="ncard__title">{t.societyListTitle}</h3>
          </div>
        </div>
        <DataTable
          style={{ width: '100%' }}
          filterDisplay="row"
          sortField="createdAt"
          sortOrder={-1}
          className="TableSignatures ntable"
          value={societies}
          emptyMessage={t.noSocietyFound}
          responsiveLayout="scroll"
          paginator
          rows={10}
        >
          <Column
            field="codSociety"
            {...columnProps(t.societyCode)}
            body={({ codSociety }) => (
              <span className="ntable__num" style={{ fontWeight: 700 }}>
                {codSociety}
              </span>
            )}
          />
          <Column
            field="societyName"
            {...columnProps(t.societyNameCol)}
            body={({ societyName }) => (
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <span
                  className="navatar navatar--blue"
                  style={{ width: 30, height: 30, borderRadius: 8, fontFamily: 'inherit' }}
                >
                  {societyName?.[0]}
                </span>
                <span style={{ fontWeight: 600, fontSize: 13 }}>{societyName}</span>
              </div>
            )}
          />
          <Column
            field="createdAt"
            {...columnProps(t.creationDate)}
            body={({ createdAt }) => (
              <span className="ntable__meta">{new Date(createdAt).toLocaleDateString()}</span>
            )}
          />
          <Column
            field="atlanteUrl"
            {...columnProps(t.urlAtlante)}
            body={({ atlanteUrl }) => (
              <span
                style={{
                  fontFamily: 'var(--font-mono)',
                  fontSize: 11.5,
                  color: 'var(--ink-500)'
                }}
              >
                {atlanteUrl}
              </span>
            )}
          />
          <Column
            style={{ width: 140, textAlign: 'right' }}
            {...actionsColumnProps}
            body={({ id }) => (
              <AdminTableActions
                id={id}
                editPath="/admin/society/"
                onDelete={deleteSociety}
                deleteHeader={t.deleteSocietyHeader}
                deleteMessage={t.deleteSocietyMessage}
              />
            )}
          />
        </DataTable>
      </div>
    </>
  )
}
